import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {map} from 'rxjs/operators';
import {LdsUserService} from '../../services/lds-user.service';
import {LdsEventBusService} from '../../services/lds-event-bus.service';
import {DataAnalyticsService} from '../../data-analytics/data-analytics.service';
import {time} from '../../services/global-variables.service';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import {ViewChild} from '@angular/core';
import {IconsService} from '../../services/icons.service';
import {MatDialog} from '@angular/material/dialog';
import {TimeSelectComponent} from '../../time-select/time-select.component';
import {PopupComponent} from '../../common-components/popup/popup.component';
import {DataExportService} from '../../services/data-export.service';

@Component({
    selector: 'ds-wire-free',
    templateUrl: './wire-free.component.html',
    styleUrls: ['./wire-free.component.scss'],
    standalone: false
})


export class WireFreeComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;

  decodeUiButtonValue(value, type){
    const decodedObj = {
      upDown: 'up',
      pressType: 'short',
      count: 0
    };
    if (type === 'uiButtonPair') {
      decodedObj.upDown = (value & 0xf000) >> 12 === 0 ? 'Up' : 'Down';
    }

    const press = (value & 0x0f00) >> 8;
    if (press === 1) decodedObj.pressType = 'Short Press';
    else if (press === 2) decodedObj.pressType = 'Long Press';
    else if (press === 3) decodedObj.pressType = 'Long Release';

    decodedObj.count = (value & 0x00ff);

    return decodedObj;
  }
  constructor(private dialog: MatDialog, private exportService: DataExportService, private route: ActivatedRoute, private user: LdsUserService, private eventBus: LdsEventBusService, private dataAnalytics: DataAnalyticsService, public icons: IconsService) {
  }

  featureSet;

  timespan: string;

  public icon_margin;

  public startTime: number;

  public endTime: number;

  data: WireFreeDataSource;

  public heightStyleMain = 'lds-container SD-graph-main h250 mt-2';

  displayedColumns = ['Timestamp', 'Value'];

  public room;

  ngOnInit(): void {
    this.route.params.pipe(map(params => params['id'])).subscribe((id) => {
      this.eventBus.subscribeAll([id, 'energy-featureSets-loaded-from-storage'], () => {
        this.featureSet = this.user.batteryFeatureSets[id];
        this.user.currentModule = this.featureSet.name;
        this.room = this.user.getRoom(this.featureSet);
        if(this.room){
            this.user.currentModule = this.featureSet.name + " - " + this.room.name; 
        }
        this.changeTimeSpan('weekly');
      });
    });

  }

  loadData() {
    for (let featureId in this.featureSet.features) {
      let feature = this.user.features[this.featureSet.features[featureId]];
      if (!feature) {
        continue;
      }
      if (feature.attributes.type !== 'uiButtonPair') {
        continue;
      }

      this.dataAnalytics.getFeatureRawData(feature.featureId, this.startTime, this.endTime).subscribe(res => {
        this.data = new WireFreeDataSource(res);
        this.data.paginator = this.paginator;
      });


      break;
    }
  }

  getDate(timestamp) {
    return new Date(timestamp).toDateString();
  }

  changeTimeSpan(timespan: string) {
    this.endTime = Date.now();
    switch (timespan) {
      case 'weekly':
        this.startTime = this.endTime - time.week;
        break;
      case 'monthly':
        this.startTime = this.endTime - time.day * 30;
        break;
      case 'custom':
        this.dialog.open(TimeSelectComponent).afterClosed().subscribe(res => {
            if (res && res.timeSelected) {
              this.startTime = res.startDate.getTime();
              this.endTime = res.endDate.getTime();
            } else {
              return;
            }
        });
    }
    this.timespan = timespan;
    this.loadData();
  }

  displayProductCode(productCode) {
    return this.icons.getProductCodeDisplay(productCode);
  }

  onExportClick(){
    this.dialog.open(PopupComponent).afterClosed().subscribe(res => {
      this.exportService.exportData(this.featureSet, this.data.data, res, this.timespan);
    });
  }

}


class WireFreeDataSource extends MatTableDataSource<any> {
  constructor(data: any[]) {
    super(data);
  }
}
